<template>
  <div class="share-dropdown" :class="{ 'is-open': shareLink }" @click.stop>
    <button class="popup__close-btn" ref="button" @click="viewLink">
      <icon name="share-icon" />
    </button>
    <div ref="dropdown" class="dropdown-menu">
      <IconButton
        class="dropdown-menu__close-button"
        icon="close-icon"
        size="super-small"
        color="secondary"
        @click="toggleDropdown"
      />
      <div class="dropdown-menu__title">קישור לשיעור</div>
      <div class="dropdown-menu__subtitle">
        באפשרותך להעתיק קישור לשיעור זה או לשלוח הודעה ישירות למורה
      </div>
      <div class="dropdown-menu__list">
        <a
          target="_blank"
          class="dropdown-menu__link"
          v-clipboard:copy="link"
          v-clipboard:success="onCopy"
        >
          <icon name="website-icon" />
          <span class="copy-link">העתק קישור לשיעור</span>
          <icon name="copy-icon-grey" />
        </a>
        <NewButton
          color="success"
          text="שלח קישור למורה"
          size="medium"
          class="send-message"
          iconStart="telegram-icon"
          :disabled="disabled"
          @click="sendMessage"
        ></NewButton>
      </div>
    </div>
  </div>
</template>

<script>
import { tippy } from 'vue-tippy';
import IconButton from '../UI/Buttons/IconButton.vue';
import NewButton from '../UI/Buttons/NewButton.vue';

export default {
  components: { IconButton, NewButton },
  props: {
    link: {
      type: String
    },
    lesson_id: {
      type: [String, Number]
    }
  },
  data() {
    return {
      dropdownOpen: true,
      shareLink: false,
      disabled: false
    };
  },
  mounted() {
    this.tippyInstance = tippy(this.$refs.button, {
      content: this.$refs.dropdown,
      placement: 'bottom-start',
      trigger: 'click',
      interactive: true,

      onShow: () => {
        this.shareLink = true;
      },
      onHide: () => {
        this.shareLink = false;
      }
    });
  },
  methods: {
    sendMessage() {
      this.$emit('sendMessage', this.lesson_id);
      this.disabled = true;
    },
    viewLink() {
      this.shareLink = true;
      this.$emit('createLink', this.lesson_id);
    },
    onCopy() {
      this.$toastr.s('הקישור הועתק בהצלחה');
    },
    toggleDropdown() {
      this.shareLink = false;
      this.tippyInstance.hide();
      //   this.$emit('toggleShare');
    }
  }
};
</script>

<style scoped lang="scss">
.send-message {
  padding: 0 16px !important;
}
.popup__close-btn {
  svg {
    stroke: #38455d;
  }
}
.copy-link {
  display: inline-block;
  width: auto;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-align: center;
}
.contact_phone {
  direction: ltr;
}
.share-dropdown {
  position: relative;
}

.dropdown-menu {
  position: relative;
  top: 0 !important;
  left: 0;
  max-height: 500px;
  background: #ffffff;
  box-shadow: 0px 8px 20px -4px rgba(56, 69, 93, 0.08),
    0px 4px 12px -4px rgba(56, 69, 93, 0.04);
  border-radius: 8px;
  width: auto;
  padding: 16px;
  z-index: 10;
  border-top: 1px solid #ccc;
  &::-webkit-scrollbar {
    width: 8px;
    border-radius: 2px;
    background-color: #ebeef5;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #cfd3de;
    border-radius: 2px;
  }
  &__close-button {
    position: absolute;
    top: 16px;
    left: 16px;
  }
  &__title {
    font-weight: 600;
    font-size: 20px;
    line-height: 24px;
    text-align: right;
    color: #38455d;
    margin-bottom: 8px;
  }
  &__subtitle {
    font-size: 14px;
    line-height: 20px;
    text-align: right;
    color: #5a6f95;
    margin-bottom: 32px;
  }
  &__list {
    display: grid;
    gap: 8px;
    // margin-bottom: 32px;
  }
  &__link {
    padding: 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    stroke: #5a6f95;
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    text-align: right;
    color: #38455d;
    border: 1px solid #e3e7ee;
    border-radius: 8px;
    transition: 0.3s;
    cursor: pointer;
    &:hover {
      color: #38455d;
      background: #eef7ff;
      border-color: #eef7ff;
    }
  }
  &__footer {
    border-top: 1px solid #e3e7ee;
    padding: 16px;
    margin-left: -16px;
    margin-right: -16px;
    margin-bottom: -16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  @media (max-width: 767px) {
    .send-message {
      padding: 0 4px !important;
    }
  }
}
</style>
